import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { useContext } from "react";

function SideBar() {
  const navigate = useNavigate();
  const [masterDropdown, setMasterDropdown] = useState(false);
  const [projectProgressDropdown, setProjectProgressDropdown] = useState(false);
  const [letter, setLetter] = useState(false);
  const { user } = useContext(AuthContext);

  return (
    <div className="sidebar">
      <ul className="sidebar-menu">
        <li id="dashboard" onClick={() => navigate("/dashboard")}>
          <i className="fas fa-briefcase"></i> Dashboard
        </li>

        <li
          id="master"
          className="master-menu dropdown-master"
          onClick={() => setMasterDropdown(!masterDropdown)}
        >
          <span>
            <i className="fas fa-briefcase"></i> Master
          </span>
          <i
            className={`fas fa-chevron-down dropdown-toggle ${
              masterDropdown ? "rotated" : ""
            }`}
          ></i>
        </li>
        <ul
          id="master-pages"
          style={{
            display: masterDropdown ? "flex" : "none",
            opacity: masterDropdown ? 1 : 0,
            height: masterDropdown ? "auto" : "0",
          }}
        >
          <li onClick={() => navigate("/division-master")}>Division Master</li>
          <li onClick={() => navigate("/range-master")}>Range Master</li>
          <li onClick={() => navigate("/timber-master")}>Timber Master</li>
          <li onClick={() => navigate("/props-master")}>Props Master</li>
          <li onClick={() => navigate("/subject-master")}>Subject Master</li>
          <li onClick={() => navigate("/project-master")}>Project Master</li>
        </ul>

        <li
          id="project-progress"
          className="master-menu dropdown-master"
          onClick={() => setProjectProgressDropdown(!projectProgressDropdown)}
        >
          <span>
            <i className="fas fa-briefcase"></i> Project Progress
          </span>
          <i
            className={`fas fa-chevron-down dropdown-toggle ${
              projectProgressDropdown ? "rotated" : ""
            }`}
          ></i>
        </li>
        <ul
          id="master-pages"
          style={{
            display: projectProgressDropdown ? "flex" : "none",
            opacity: projectProgressDropdown ? 1 : 0,
            height: projectProgressDropdown ? "auto" : "0",
          }}
        >
          <li onClick={() => navigate("/project-progress/receipt-entry")}>
            Receipt Entry
          </li>
          <li onClick={() => navigate("/project-progress/disposal-entry")}>
            Disposal Entry
          </li>
          <li onClick={() => navigate("/project-progress/monthly-report")}>
            Monthly Project Progress Report
          </li>
        </ul>

        <li
          id="letter"
          className="master-menu dropdown-master"
          onClick={() => setLetter(!letter)}
        >
          <span>
            <i className="fas fa-briefcase"></i> Letter
          </span>
          <i
            className={`fas fa-chevron-down dropdown-toggle ${
              letter ? "rotated" : ""
            }`}
          ></i>
        </li>
        <ul
          id="master-pages"
          style={{
            display: letter ? "flex" : "none",
            opacity: letter ? 1 : 0,
            height: letter ? "auto" : "0",
          }}
        >
          <li onClick={() => navigate("/letter/receive")}>Receive</li>
          <li onClick={() => navigate("/letter/dispatch")}>Dispatch</li>
          <li onClick={() => navigate("/letter/letter-report")}>
            Letter Wise Report
          </li>
          <li onClick={() => navigate("/letter/data-range")}>
            Data Range Report
          </li>
          <li onClick={() => navigate("/letter/division-wise-report")}>
            Division Wise Report
          </li>
        </ul>

        {/* <li
          id="report"
          className="master-menu dropdown-master"
          onClick={() => setReportDropdown(!reportDropdown)}
        >
          <span>
            <i className="fas fa-briefcase"></i> Report
          </span>
          <i
            className={`fas fa-chevron-down dropdown-toggle ${
              reportDropdown ? "rotated" : ""
            }`}
          ></i>
        </li>
        <ul
          id="report-pages"
          style={{
            display: reportDropdown ? "flex" : "none",
            opacity: reportDropdown ? 1 : 0,
            height: reportDropdown ? "auto" : "0",
          }}
        >
          <li onClick={() => navigate("/pending-report")}>Pending Report</li>
          <li onClick={() => navigate("/accepted-report")}>Accepted Report</li>
        </ul> */}
      </ul>
    </div>
  );
}

export default SideBar;
